import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IDescription } from 'src/app/shared/models/description.model';
import { IBasePerson } from 'src/app/shared/people/models/person';
import { IHello } from '../hello.model';
import { ImpersonateRepository } from '../repositories/impersonate.repository';

@Injectable({
  providedIn: 'root'
})
export class ImpersonateService {
  
  constructor(
    private impersonateRepository: ImpersonateRepository
  ) { }

  /**
   * Identifies the current user
   *
   * @returns {Observable<string>} the username being impersonated, or the actually logged in user
   * @memberof UserRepository
   */
  public whoAmI(): Observable<string> {
    return this.impersonateRepository.whoAmI().pipe(
      map((wrapper: IDescription) => wrapper.description)
    );
  }

  /**
   * Say hello to the current user
   */
  public helloUser(): Observable<IHello> {
    return this.impersonateRepository.getPerson();
  }

  public getUsernameFromLuid(luid: string): Observable<{ value: string }> {
    return this.impersonateRepository.getUsernameFromLuid(luid).pipe(
      map(value => {
        return {value: value.description};
      })
    );
  }

  /**
   * Impersonate's username passed in
   *  Api will issue a redirect if successful
   * @param username
   */
  public impersonateUser(username: string): Observable<IHello> {
    return this.impersonateRepository.impersonateUser(username);
  }

  /**
   * Exit impersonate session
   */
  public stopImpersonating(): Observable<IBasePerson> {
    return this.impersonateRepository.stopImpersonating();
  }
}
